const REACT_APP_COGNITO_AUTHORITY = process.env.REACT_APP_COGNITO_AUTHORITY || window._env_.REACT_APP_COGNITO_AUTHORITY;

const REACT_APP_COGNITO_CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID || window._env_.REACT_APP_COGNITO_CLIENT_ID;

const REACT_APP_COGNITO_DOMAIN = process.env.REACT_APP_COGNITO_DOMAIN || window._env_.REACT_APP_COGNITO_DOMAIN;

const REACT_APP_HOST = process.env.REACT_APP_HOST || window._env_.REACT_APP_HOST;

const REACT_APP_API_URL = process.env.REACT_APP_API_URL || window._env_.REACT_APP_API_URL;


export {
    REACT_APP_COGNITO_AUTHORITY,
    REACT_APP_COGNITO_CLIENT_ID,
    REACT_APP_COGNITO_DOMAIN,
    REACT_APP_HOST,
    REACT_APP_API_URL
};